// extracted by mini-css-extract-plugin
module.exports = {"card":"ResultItem_card__2Klhv","cardImage":"ResultItem_cardImage__2C6PP","cardContent":"ResultItem_cardContent__1bvc9","button":"ResultItem_button__2FIu9"};